import React, { FC, useContext } from 'react';
import { UiStateContext } from '../../context/UiStateContext';
import { useDataLayerPush } from '../../hooks/useDataLayerPush';
import UnAvailableMapMarker from '../../images/maps/marker-black.png';
import BranchMapMarker from '../../images/maps/marker-branch.png';
import AvailableMapMarker from '../../images/maps/marker-red.png';
import Blade from '../Blade';
import { Map, MapMarker } from '../Map';
import { Spacer } from '../Spacer';
import { PropertyMapKey } from './PropertyMapKey';

interface PropertyMapBladeProps {
  latitude: number;
  longitude: number;
  id: string | number;
  title?: string;
  category: string;
  available?: boolean;
  branch?: any; // TODO - TYPE to branch
}

const iconComponentPropertyAvailable = AvailableMapMarker;
const iconComponentPropertyUnAvailable = UnAvailableMapMarker;
const iconComponentBranch = BranchMapMarker;

export const PropertyMapBlade: FC<PropertyMapBladeProps> = ({
  available,
  latitude,
  longitude,
  id,
  title,
  category,
  branch,
}) => {
  const { dataLayerPush } = useDataLayerPush();
  const { setActiveBlade } = useContext(UiStateContext);

  const branchMarker = {
    id: branch?.id,
    type: 'branch',
    iconComponent: iconComponentBranch,
    onClick: () => {
      setActiveBlade('branch');

      dataLayerPush({
        event: 'map pin click',
        clickType: 'KFH Branch',
        clickHostname: undefined,
        clickPath: undefined,
        clickQueryString: undefined,
        clickBladeId: 'branch',
      });
    },
    position:
      category === 'RESALE'
        ? {
            lat: branch?.salesLat,
            lng: branch?.salesLon,
          }
        : {
            lat: branch?.lettingsLat,
            lng: branch?.lettingsLon,
          },
  };

  const mapMarkers: MapMarker[] = [
    {
      id,
      type: available ? 'property-available' : 'property-unavailable',
      iconComponent: available ? iconComponentPropertyAvailable : iconComponentPropertyUnAvailable,
      position: {
        lat: latitude,
        lng: longitude,
      },
    },
  ];
  // handle no branch data
  if (branchMarker?.position?.lat && branchMarker?.position?.lng) {
    mapMarkers.push(branchMarker);
  }
  return (
    <Blade id="propertyMap" renderChildrenOnOpen width="wide" heading={title}>
      <Spacer>
        <Map markers={mapMarkers} mapStyle="properties" />
        <PropertyMapKey category={category} />
      </Spacer>
    </Blade>
  );
};
